import React from "react";
import { constants } from "../../utils/constants";
import { CommunitybackgroundImage, discordSq, facebookSq, instaSq, telegramSq, tubeSq, twitterSq } from "../../images/general";
import { OutboundLink } from 'gatsby-plugin-gtag'

const Community = () => {
  return (
    <>
      <section
        id="community"
        style={{ backgroundImage: `url(${CommunitybackgroundImage})` }}
        className="w-full bg-no-repeat bg-cover h-full py-1 bg-center"
      >
        <div className="container max-w-7xl px-4 mx-auto sm:py-24 py-16"
                    data-sal="slide-down"
                    data-sal-delay="400"
                    data-sal-easing="ease">
          <h3 className="sm:text-[56px] text-[28px] font-cinzel text-white font-bold sm:leading-[56px] leading-7 mx-auto sm:max-w-4xl sm:w-3/4 text-center sm:mb-10 mb-6">
            Join our #MedievalEmpires Online Community!
          </h3>
          <p className="sm:block hidden text-white font-cinzel font-bold sm:text-2xl text-lg sm:leading-8 leading-[18px] text-center mx-auto sm:max-w-3xl sm:w-1/2 mb-10">
            Stay up to date about our game, airdrops, giveaways and more
          </p>
          <div className="sm:hidden block mb-8">
            <p className="text-white font-cinzel font-bold sm:text-2xl text-lg sm:leading-8 leading-5 text-center mx-auto sm:max-w-3xl sm:w-1/2">
              Stay up to date about
            </p>
            <p className="text-white font-cinzel font-bold sm:text-2xl text-lg sm:leading-8 leading-5 text-center mx-auto sm:max-w-3xl sm:w-1/2">
              our game, airdrops, giveaways
            </p>
            <p className="text-white font-cinzel font-bold sm:text-2xl text-lg sm:leading-8 leading-5 text-center mx-auto sm:max-w-3xl sm:w-1/2">
              and more
            </p>
          </div>
          <div className="mx-auto sm:w-2/5 w-[55%]">
            <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 place-items-center">
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.discord} target="_blank">
                  <img src={discordSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12 sm:mb-0 mb-4" />
                </OutboundLink>
              </div>
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.twitter} target="_blank">
                  <img src={twitterSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12 sm:mb-0 mb-4" />
                </OutboundLink>
              </div>
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.instagram} target="_blank">
                  <img src={instaSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12 sm:mb-0 mb-4" />
                </OutboundLink>
              </div>
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.telegram} target="_blank">
                  <img src={telegramSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12" />
                </OutboundLink>
              </div>
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.facebook} target="_blank">
                  <img src={facebookSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12" />
                </OutboundLink>
              </div>
              <div className="w-max cursor-pointer ">
                <OutboundLink href={constants.youtube} target="_blank">
                  <img src={tubeSq} className="hover:animate-bounce sm:w-max w-12 sm:h-max h-12" />
                </OutboundLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Community;
